var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as languages from '../../constants/Language';
import { changeLocale as changeLocaleAction } from '../../actions/creators/locale';
var Locale = /** @class */ (function (_super) {
    __extends(Locale, _super);
    function Locale() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.changeLocale = function (language) { return function (e) {
            e.preventDefault();
            _this.props.changeLocaleAction(language);
        }; };
        return _this;
    }
    Locale.prototype.render = function () {
        var languageId = this.props.languageId;
        var ruSelectedCls = languageId === languages.RU ? ' selected' : '';
        var enSelectedCls = languageId === languages.EN ? ' selected' : '';
        var uzSelectedCls = languageId === languages.UZ ? ' selected' : '';
        return (_jsx("li", { children: _jsxs("div", __assign({ id: 'language-form', className: 'unauth' }, { children: [_jsxs("a", __assign({ href: '!#', className: "language__item".concat(ruSelectedCls), onClick: this.changeLocale(languages.RU) }, { children: [_jsx("div", { className: 'language__item__img-wrapper', style: { backgroundImage: "url(".concat(require('../../assets/img/flag-ru.svg'), ")") } }), "\u0420\u0443\u0441\u0441\u043A\u0438\u0439"] })), _jsxs("a", __assign({ href: '!#', className: "language__item".concat(enSelectedCls), onClick: this.changeLocale(languages.EN) }, { children: [_jsx("div", { className: 'language__item__img-wrapper', style: { backgroundImage: "url(".concat(require('../../assets/img/flag-en.svg'), ")") } }), "English"] })), _jsxs("a", __assign({ href: '!#', className: "language__item".concat(uzSelectedCls), onClick: this.changeLocale(languages.UZ) }, { children: [_jsx("div", { className: 'language__item__img-wrapper', style: { backgroundImage: "url(".concat(require('../../assets/img/flag-uz.svg'), ")") } }), "O'zbek"] }))] })) }));
    };
    Locale.propTypes = {
        languageId: PropTypes.number.isRequired,
        changeLocaleAction: PropTypes.func.isRequired
    };
    return Locale;
}(React.Component));
var mapStateToProps = function (state) { return ({
    languageId: state.application.get('languageId'),
    countryCode: state.application.get('client').country,
}); };
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    changeLocaleAction: changeLocaleAction
}, dispatch); };
Locale = connect(mapStateToProps, mapDispatchToProps)(Locale);
export default Locale;



// WEBPACK FOOTER //
// ./src/components/sidebar/Locale.jsx